var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "AppModal",
    {
      staticClass: "w-full",
      attrs: { id: _vm.id, options: _vm.options, title: "Import Movies" }
    },
    [
      _c("p", { staticClass: "text-gray-700 leading-relaxed mb-3" }, [
        _vm._v(" You can import movies from the following sources: ")
      ]),
      _c(
        "div",
        {
          staticClass: "grid gap-4 grid-cols-fill-32 desktop:grid-cols-fill-40"
        },
        _vm._l(_vm.sources, function(source) {
          return _c("div", { key: source, staticClass: "relative ratio-1/1" }, [
            _c("div", { staticClass: "absolute inset-0 flex" }, [
              _c(
                "button",
                {
                  staticClass:
                    "\n                        relative flex items-center justify-center w-full h-full\n                        shadow border border-gray-400 hover:bg-gray-300\n                    ",
                  attrs: {
                    type: "button",
                    title: "Import from " + _vm.mediaSourceNames[source],
                    "aria-label": "Import from " + _vm.mediaSourceNames[source]
                  },
                  on: {
                    click: function($event) {
                      return _vm.importMedia(source)
                    }
                  }
                },
                [
                  source === "netflix"
                    ? _c("BaseIcon", {
                        staticClass: "w-full h-full",
                        attrs: { name: source }
                      })
                    : source !== "goodfilms"
                    ? _c("BaseIcon", {
                        staticClass: "w-24 h-24",
                        attrs: { name: source }
                      })
                    : _c(
                        "div",
                        {
                          staticClass:
                            "w-24 h-24 p-2 flex items-center justify-center",
                          staticStyle: { background: "#2c2c2c" }
                        },
                        [
                          _c("img", {
                            attrs: {
                              src: require("@/assets/img/logos/goodfilms.png")
                            }
                          })
                        ]
                      )
                ],
                1
              ),
              source !== "imdb"
                ? _c(
                    "button",
                    {
                      staticClass:
                        "absolute top-0 right-0 m-2 text-blue-400 hover:text-blue-600",
                      attrs: {
                        type: "button",
                        title: "Get help about this import method"
                      },
                      on: {
                        click: function($event) {
                          return _vm.$ui.openFileMarkdownModal(
                            "import-" + source,
                            _vm.helpReplacements[source]
                          )
                        }
                      }
                    },
                    [
                      _c("BaseIcon", {
                        staticClass: "w-5 h-5",
                        attrs: { name: "question" }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ])
          ])
        }),
        0
      ),
      _c(
        "p",
        { staticClass: "text-gray-700 leading-relaxed my-3" },
        [
          _vm._v(
            " If you can't import your movies with any of these options, please "
          ),
          _c("BaseLink", { attrs: { url: _vm.requestSourceUrl } }, [
            _vm._v(" let me know ")
          ]),
          _vm._v(" and I'll help you. ")
        ],
        1
      ),
      _c(
        "p",
        { staticClass: "text-gray-700 leading-relaxed" },
        [
          _vm._v(" In the meantime, you can probably find your movies "),
          _c("BaseLink", { on: { click: _vm.openSearch } }, [
            _vm._v(" using the search in the header ")
          ]),
          _vm._v(". ")
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }